import React from 'react';
import { Grid } from '@material-ui/core';


import Flashes from '+/flashes/Container';

const AuthLayout = props => (
    <>
        <Flashes />
        <Grid container id='auth'>
            <Grid id='content' item xs={6}>
                { props.children }
            </Grid>

            <Grid id='brand' item xs={6}>
                <img alt='UPM' src='https://images1.apartments.com/i2/EhA4e12LGr_6IENncdHCxC8CIHBDD_jh2nYiZkLPi78/111/miami-bay-waterfront-midtown-residences-miami-fl-primary-photo.jpg' />
            </Grid>

        </Grid>
    </>
);

export default AuthLayout;
